import { userService } from "../services";
import config from "../config/config";

export const VehicleActions = {
  fetchVehicleTypeList,
  fetchSaveVehicleType,
};

async function fetchSaveVehicleType(payload) {
  try {

    // let apiEndpoint = `${config.baseUrl}${config.apiName.summaryReport}${payload.fromDate}/${payload.toDate}/${payload.employeeId}/${payload.hrmsUserId}`
    let apiEndpoint = `${config.baseUrl}${config.apiName.saveVehicleType}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchVehicleTypeList(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.getVehicleTypeList}`;
    const response = await userService.get(apiEndpoint);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

function buildUrl(baseUrl, params) {
  const url = new URL(baseUrl);

  // Filter and append valid params
  Object.entries(params).forEach(([key, value]) => {
    if (value != null) {
      url.searchParams.append(key, value);
    }
  });

  return url.toString();
}
